// extracted by mini-css-extract-plugin
export default {"AddVesselModal":"Style_AddVesselModal__V6kPs"};